import { render } from "./DemoCard.vue?vue&type=template&id=1574bb28&scoped=true"
import script from "./DemoCard.vue?vue&type=script&lang=js"
export * from "./DemoCard.vue?vue&type=script&lang=js"

import "./DemoCard.vue?vue&type=style&index=0&id=1574bb28&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1574bb28"]])

export default __exports__